import axios from 'axios';

let baseURL = 'http://211.152.9.7:8080/movies/api';

// if(process.env.NODE_ENV=="development"){
//   baseURL=''
// }else{
//   baseURL=''
// }

let config = {
  baseURL: baseURL,
  timeout: 30000
}
const _axios = axios.create(config)
/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
  config => {
    config.headers.token = 'helen123456';
    return config;
  },
  err => Promise.reject(err)
);
/* 请求之后的操作 */
_axios.interceptors.response.use(
  res => {
    if (res.data.code === 401 ) {
     // this.$toast("无权限操作")
    }
	if (res.data.code === 400 ) {
    //this.$toast("请求网络失败")
	}
	if (res.data.code === 404 ) {
    //this.$toast("请求网络失败")
	}
    return res;
  },
  err => {
    if (err) {
      //this.$toast("请求网络失败")
    }
    return Promise.reject(err);
  }
);
const http = {
  get(url='',params={}){
    return new Promise((resolve, reject) => {
      _axios({
        url,
        params,
        headers:{'Content-Type': 'application/json;charset=UTF-8'},
        method: 'GET'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        reject(error)
      })
    })
  },
  post(url='',params={}){
    return new Promise((resolve, reject) => {
      _axios({
        url,
        data:params,
        headers:{'Content-Type': 'application/json;charset=UTF-8'},
        method: 'POST'
      }).then(res => {
        resolve(res.data)
        return res
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default http


// WEBPACK FOOTER //
// ./src/api/http.js